export const DEFAULT_APPOINTMENT_REASON_VALUE = '__consultation__';

export const isDefaultAppointmentReasonName = (value?: string | null) => {
  const normalized = value?.trim().toLocaleLowerCase();
  return normalized === 'consulta' || normalized === 'consultation';
};
